/**
 * Notification module (Vuex).
 *
 * Hanya menyimpan `type` + `message` ke state — komponen UI yang menampilkan
 * (mis. alert banner) bertanggung jawab membaca state ini dan render-nya.
 *
 * Action `error` melakukan translasi pesan teknis dari backend
 * (mis. "unauthenticated") menjadi pesan ramah user sebelum disimpan.
 */

const SESSION_EXPIRED_MESSAGE =
    'Sesi Anda telah berakhir. Silakan login kembali.';

const AUTH_ERROR_KEYWORDS = [
    'unauthenticated',
    'unauthorized',
    'token mismatch',
    'invalid token',
    'token expired',
    'token has expired',
    'invalid signature',
    'token not provided',
];

/**
 * Translate payload error (string, Error object, atau response data) ke pesan
 * yang ramah user.
 *
 *   - Auth-related (unauthenticated, token expired, dll) -> SESSION_EXPIRED_MESSAGE
 *   - Pesan kosong/null -> fallback default
 *   - Pesan lain -> dipakai apa adanya
 */
function humanizeMessage(payload) {
    let msg = '';

    if (typeof payload === 'string') {
        msg = payload;
    } else if (payload && typeof payload === 'object') {
        msg =
            payload.message ||
            payload?.response?.data?.message ||
            payload?.data?.message ||
            '';
    }

    msg = String(msg || '').trim();
    if (!msg) {
        return 'Terjadi kesalahan. Silakan coba lagi.';
    }

    const lower = msg.toLowerCase();
    if (AUTH_ERROR_KEYWORDS.some((kw) => lower.includes(kw))) {
        return SESSION_EXPIRED_MESSAGE;
    }

    return msg;
}

export const state = {
    type: null,
    message: null,
};

export const mutations = {
    success(state, message) {
        state.type = 'alert-success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'alert-danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    },
};

export const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, payload) {
        // Translate pesan teknis (mis. "unauthenticated") jadi pesan
        // ramah user sebelum disimpan ke state.
        const message = humanizeMessage(payload);
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    },
};